import React from "react";
import "@frameworks/shared-library/stylesheets/components/OrderBookSideBar/SideBarClientDetails.scss";
import GenericSchemeName from "@frameworks/shared-library/components/GenericSchemeName/GenericSchemeName";
import { generateClientTierIcon } from "@frameworks/shared-library/components/TransactionJourney/MutualFund/MutualFundConstant";
import { alphabetsColorsConfigMap } from "@frameworks/shared-library/components/TextFirstAlphabetAsIcon/colorConfigurationsForTextFirstAlphabetAsIcon";
/**
 * SideBarClientDetails
 *
 * This component is used to display client details on sidebar
 *
 * @param {string} clientName - Client name
 * @param {string} clientCode - Client code
 * @param {string} uniqueClientId- Client's unique ID
 * @param {Boolean} showTooltip - Show or hide tooltip on reaching max width when ellipsed
 * @param {string} clientTier - Index icon on Client image - indicating which tier they belog to
 * @returns {}
 */
var SideBarClientDetails = function (props) {
    var _a, _b;
    return (React.createElement("div", { className: "DMSanN_14_400 d-flex align-items-center client-name-bar justify-content-center ".concat((_a = props === null || props === void 0 ? void 0 : props.parentClassName) !== null && _a !== void 0 ? _a : "") },
        React.createElement(GenericSchemeName, { name: props.clientName, showTooltip: true, maxWidth: 145, badgeIcon: generateClientTierIcon(props === null || props === void 0 ? void 0 : props.clientTier), showImage: true, parentClassName: (_b = props === null || props === void 0 ? void 0 : props.clientTier) === null || _b === void 0 ? void 0 : _b.toLowerCase(), textAndBackgroundColorCollectionConfig: alphabetsColorsConfigMap, tooltipPlacement: props === null || props === void 0 ? void 0 : props.tooltipPlacement }),
        React.createElement("i", { className: "edel-icon-round-circle" }),
        React.createElement("label", { className: "DMsanR_12_300 unique-client-class" }, props.uniqueClientId),
        React.createElement("i", { className: "edel-icon-round-circle" }),
        React.createElement("label", { className: "DMsanR_12_300 pan-class" }, props.pan)));
};
export default SideBarClientDetails;
